import { createAxios, logNative } from '../../utils/utils';
import {
  APP_ADETAILS_70,
  APP_DETAILS_GIFT_70,
  APP_DETAILS_GIFT_RECEIVE_70,
  SPECIAL_COLLECT_SET_72,
  SPECIAL_COLLECT_CANCEL_72,
  SEARCH_RECOMMEND_NEW_61,
  GROUNP_CONTENT_53,
} from '../../config';
import React from 'react';
import Toast from '../../components/Toast/Toast';
import styles from './SoftDetailMore.module.less';

export default {
  async getAAppDetails({ pn, vc, bizInfo }) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.get(APP_ADETAILS_70, {
        params: { pn, vc, bizInfo: bizInfo || {} },
      });

      if (res.data.status === 0) {
        return { ...res.data.data, paramPN: pn, loading: false };
      } else {
        return { ...res.data, paramPN: pn, loading: false };
      }
    } catch (error) {
      logNative(`获取安卓软件详情错误${error}`);
      // throw error;
    }
  },
  async getAAppGift({ softInfo, androidType }) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.get(APP_DETAILS_GIFT_70, {
        params: { softInfo, androidType },
      });

      if (res.data && res.data.status === 0) {
        return {
          dataList: [...res.data.data],
          softInfo,
        };
      }
    } catch (error) {
      logNative(`获取安卓礼包${error}`);
      // throw error;
    }
  },
  async appAGiftReceive(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.get(APP_DETAILS_GIFT_RECEIVE_70, {
        params,
      });

      if (res.data) {
        if (res.data.status === 0) {
          Toast.success({
            content: res.data.message,
          });
        } else {
          Toast.error({
            content: res.data.message,
          });
        }
      }

      if (res.data) {
        return {
          loading: false,
          data: res.data,
          ...params,
        };
      }
    } catch (error) {
      // throw error;
    }
  },
  async addCollectSpecial(payload, anAppInfo) {
    const axios = await createAxios('isNeedUser');
    const res = await axios.get(SPECIAL_COLLECT_SET_72, {
      params: payload,
    });

    try {
      if (res && res.data && res.data.status === 0) {
        Toast.success({
          content: <div>收藏成功!</div>,
        });

        return {
          ...anAppInfo,
          hasCollect: 1,
        };
      } else {
        Toast.error({
          content: '收藏失败!',
        });
      }
    } catch (err) {
      logNative(err);
    }
  },
  async deleteCollectSpecial(payload, anAppInfo) {
    const axios = await createAxios('isNeedUser');
    const res = await axios.get(SPECIAL_COLLECT_CANCEL_72, {
      params: payload,
    });
    try {
      if (res && res.data && res.data.status === 0) {
        Toast.success({
          content: <div className={styles.toast}>取消收藏成功!</div>,
          className: styles.toast_img,
        });

        // 安卓软件-详情页面
        return {
          ...anAppInfo,
          hasCollect: 0,
        };
      } else {
        Toast.error({
          content: <div className={styles.toast}>取消收藏失败!</div>,
          className: styles.toast_img,
        });
      }
    } catch (err) {
      logNative(err);
    }
  },
  async geAppRecommend({ softInfo, androidType, source }) {
    try {
      const axios = await createAxios();
      const res = await axios.get(SEARCH_RECOMMEND_NEW_61, {
        params: { softInfo, androidType, source },
      });
      if (res.data.status === 0) {
        return { ...res.data.data, softInfo, androidType, source };
      }
    } catch (error) {
      // throw error;
    }
  },
  async getAAppGroup(params) {
    try {
      const axios = await createAxios();
      const res = await axios.get(GROUNP_CONTENT_53, {
        params: {
          pageType: params.pageType,
          ztType: params.ztType,
        },
      });

      if (res.data && res.data.status === 0) {
        return {
          dataList: [...res.data.data],
          ...params,
        };
      }
    } catch (error) {
      // throw error;
    }
  },
};
